import CollapsibleSection from './CollapsibleSection';

export default CollapsibleSection;
